// hooks/utils/excerptMappingUtils.js
import { excerptKeys } from '../excerpts/queries';

/**
 * Helper function to map excerpts to paragraphs and cache the mappings
 * @param {Array} paragraphs - Array of paragraph objects with start and end properties
 * @param {Array} excerpts - Array of excerpt objects to map to paragraphs
 * @param {string|number} codeableId - ID of the codeable entity (transcript or survey answer)
 * @param {string} codeableType - Type of codeable entity ('Transcript' or 'SurveyAnswer')
 * @param {Object} queryClient - React Query client for caching
 */
export const mapExcerptsToParagraphs = (paragraphs, excerpts, codeableId, codeableType, queryClient) => {
  if (!paragraphs?.length || !excerpts?.length || !codeableId || !queryClient) return;

  // Map excerpts to paragraphs
  paragraphs.forEach(paragraph => {
    const relevantExcerptIds = excerpts
      .filter(excerpt => !(excerpt.end <= paragraph.start || excerpt.start >= paragraph.end))
      .map(excerpt => excerpt.id);

    if (relevantExcerptIds.length > 0) {
      queryClient.setQueryData(
        excerptKeys.paragraphExcerptIds(codeableId, codeableType, paragraph.start, paragraph.end),
        relevantExcerptIds
      );
    }
  });
};
